import axios from "axios";
import { convertShoppingCartStringToArray } from "helpers/ShoppingCartFunctions";

const API_BASE_URL = `${process.env.REACT_APP_LARAVEL_API_HOST}/api`;
const TOKEN = process.env.REACT_APP_LARAVEL_API_TOKEN;

export const getBrands = async (category) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/afinazone/brands/${category}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching brands:", error);
    return ["Error fetching brands"];
  }
};


export const getModelsFromBrand = async (category, brand) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/afinazone/models/${category}/${brand}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching models:", error);
    return ["Error fetching models"];
  }
};

export const getProducts = async (category, brand, model, variant) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/afinazone/variants/${category}/${brand}/${model}/${variant}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching products:", error);
    return ["Error fetching products"];
  }
};

export const getProductData = async (category, id) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/afinazone-items/${category}/${id}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching product:", error);
    return ["Error fetching product"];
  }
};

export const getShoppingCartData = async () => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/afinazone-shopping-cart`,
      {
        items: convertShoppingCartStringToArray(),
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching product:", error);
    return ["Error fetching product"];
  }
};

export const createOrder = async (orderData) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/afinazone-add-order`,
      orderData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error creating order:", error);
    return { status: 'error', message: 'Failed to create order.' };
  }
};

export const getBestSellers = async () => {
  const response = await axios.get(
    `${API_BASE_URL}/best-sellers`,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response;
};

export const getOilTypes = async () => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/afinazone/aceite/types`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching oil types:", error);
    return ["Error fetching oil types"];
  }
};

export const getOilBrandsOfType = async (type) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/afinazone/aceite/brands/${type}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching oil types:", error);
    return ["Error fetching oil types"];
  }
};

export const getVariants = async (type, brand) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/afinazone/aceite/variants/${type}/${brand}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching oil variants:", error);
    return ["Error fetching oil variants"];
  }
};

export const getOil = async (type, brand, characteristic, unit) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/afinazone/aceite/detalle/${type}/${brand}/${characteristic}/${unit}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching oil product:", error);
    return ["Error fetching oil product"];
  }
};

export const getPedido = async (uuid) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/afinazone/pedido/${uuid}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching pedido:", error);
    return ["Error fetching pedido"];
  }
};

export const getPedidos = async (body) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/afinazone/user/pedidos`,
      body,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log("Error fetching pedidos:", error);
    return ["Error fetching pedidos"];
  }
};

export const getAllProductsToSearch = async (body) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/afinazone/search/products`,
      body,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log("Error fetching busqueda de productos:", error);
    return ["Error fetching busqueda de productos"];
  }
};

window.getShoppingCartData = getShoppingCartData;
